import { fetchInstockDetailSingleProduct, fetchInstockProductApi } from "../../../../api/ViewproductApi";
import { useEffect, useState } from "react";
import CustomTable from "../../../controls/CustomTable";
import Loading from "../../../controls/Loading";
import Icon from "../../../../assets/icons/Icon";
import { isMobileView } from "../../../controls/CommonFunctions";
const ProductInstock = ({ productData }) => {
    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showTableDetail, setShowTableDetail] = useState(false);
    const [itemLedgerData, setItemLedgerData] = useState([]);
    const [itemLedgerDataLoading, setItemLedgerDataLoading] = useState(false);
    const [storeName, setStoreName] = useState('');


    useEffect(() => {
        fetchData(productData.key);

    }, []);

    const fetchData = async (productId) => {
        setLoading(true); // Start loading
        try {
            const data = await fetchInstockProductApi(productId);
            console.log("data in stock qty", data);
            setStockData(data.inStock);
        } catch (error) {
            toast.error("Failed to load data!");
        } finally {
            setLoading(false); // Stop loading
        }
    };


    const fetchInstockDetailData = async (productId, locationId) => {
        setItemLedgerDataLoading(true);
        try {
            const data = await fetchInstockDetailSingleProduct(productId, locationId);
            console.log("data in stock qty detail ledger", data);
            setItemLedgerDataLoading(false);
            setItemLedgerData(data.itemLedgers);
        } catch (error) {
            toast.error("Failed to load data!");
            setItemLedgerDataLoading(false);
        }
    };

    // Columns for the first table
    const columns = [
        { field: "StoreName", headerName: "Store Name" },
           { field: "Location", headerName: "Location" },
        { field: "InStockQty", headerName: "Stock Qty" },
    ];

    // Map stock data to rows and include productData fields
    const rows = stockData.map((item) => ({
        StoreName: item.StoreName,
        InStockQty: item.InStockQty,
        LocationID: item.LocationID,
        Location:item.Location


    }));

    const handleOnRow = (row) => {
        setShowTableDetail(true);
        fetchInstockDetailData(productData.key, row.LocationID);
        setStoreName(row.StoreName);
        console.log("location id", row.LocationID);
        console.log(row);
    };

    // Columns for the second table
    const inDetailColumn = [
        { field: "ActionOn", headerName: "Date",type:"date" },
        { field: "Location", headerName: "Location" },
        { field: "TransactionType", headerName: "Transaction Type" },
        { field: "TransactionNo", headerName: "Transaction No" },
        { field: "Action", headerName: "Transaction Action" },
        { field: "TransactionQty", headerName: "Transaction Qty", align: "right" },
        { field: "InStockQty", headerName: "In Stock Qty", align: "right" },
    ];

    // const inDetailRow = itemLedgerData.map((item) => {
    //     const date = new Date(item.ActionOn._seconds * 1000);
    //     return {
    //         Date: `${date.getDate()} ${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][date.getMonth()]} ${date.getFullYear()}` || "N/A",
    //         ProductName: item.ProductName,
    //         ProductSKU: item.ProductSKU,
    //         BarCode: item.BarCode,
    //         Location: item.Location,
    //         TransactionType: item.TransactionType,
    //         TransactionNo: item.TransactionNo,
    //         Action: item.Action,
    //         TransactionQty: item.TransactionQty,
    //         InStockQty: item.InStockQty

    //     }
    // });



    return (
        <>
            <div className="flex-1 p-4">
                {loading && <Loading />} {/* Display loading message */}
                {!loading && rows.length > 0 && (
                    <div className={`${isMobileView() ? "flex-col" :"flex-row"} flex gap-4`}> {/* Flex container with spacing between tables */}
                        <div className={` sm:w-[25%] `}> {/* Table 1 - takes up 50% of the container width */}
                            <CustomTable handleOnRow={handleOnRow} columns={columns} rows={rows} />
                        </div>
                        {showTableDetail && (
                            <div className="sm:w-[72%]  overflow-hidden"> {/* Table 2 - takes up the other 50% */}
                                {itemLedgerDataLoading ? "Loading..." :
                                    <> <div className="mb-2 flex items-center justify-between">
                                        <span className="text-[16px]">
                                            {storeName}
                                        </span>
                                        <span
                                            className="w-6 text-(--list-item-gray) hover:text-gray-900 cursor-pointer"
                                            onClick={() => setShowTableDetail(false)} // Use an arrow function to call setShowTableDetail
                                        >
                                            <Icon type={"remove"} />
                                        </span>

                                    </div>
                           
                                        <CustomTable columns={inDetailColumn} rows={itemLedgerData} />
                                    </>
                                }
                            </div>
                        )}
                    </div>
                )}
                {!loading && rows.length === 0 && (
                    <div className=" items-center justify-center flex" >
                        No Data Available!
                    </div>
                )}
            </div>
        </>
    );
};

export default ProductInstock;

